const warehouse = {
  state: {
    allocations: {},
  },
  mutations: {
    setAllocations(state, val) {
      state.allocations = { ...state.allocations, ...val }
    },
    resetAllocations(state) {
      state.allocations = {}
    },
  },
  actions: {},
  getters: {
    getAllocations(state) {
      return state.allocations
    },
  },
}
export default warehouse
